import React from "react";
import "./index.css";

const Container = ({ children }: { children?: React.ReactNode }) => {
  return <div className="container">{children}</div>;
};

export default Container;
